/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Befreiungrentenversicherungspflichtgewuenscht2Inputs */



/**

* @param {_Field_Befreiungrentenversicherungspflichtgewuenscht2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_befreiungrentenversicherungspflichtgewuenscht2 = /** @type {((inputs?: _Field_Befreiungrentenversicherungspflichtgewuenscht2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Befreiungrentenversicherungspflichtgewuenscht2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Befreiung von der Rentenversicherungspflicht gewünscht")
});
export { _field_befreiungrentenversicherungspflichtgewuenscht2 as "_field_befreiungRentenversicherungspflichtGewuenscht" }